import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { content } from "../mock";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Default language is Arabic
  const [language, setLanguage] = useState(() => {
    const pathLang = location.pathname.split("/")[1];
    return pathLang === "ar" || pathLang === "en" ? pathLang : "ar";
  });

  const [isRTL, setIsRTL] = useState(language === "ar");

  // Update if URL changes (back/forward)
  useEffect(() => {
    const pathLang = location.pathname.split("/")[1];
    if ((pathLang === "ar" || pathLang === "en") && pathLang !== language) {
      setLanguage(pathLang);
    }
  }, [location.pathname, language]);

  useEffect(() => {
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = language === "ar" ? "ar-SA" : "en-SA";
    setIsRTL(language === "ar");
  }, [language]);

  const toggleLanguage = () => {
    const newLang = language === "en" ? "ar" : "en";

    // ✅ keep the current page path when switching language
    const parts = location.pathname.split("/");
    parts[1] = newLang;
    const newPath = parts.join("/") || `/${newLang}`;

    navigate(newPath);
  };

  const t = content[language];

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
};
